import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_ROLE_BINDING_DELETE } from "./gql";

export const useBulkStackRoleBindingDelete = createBulkMutationHook(STACK_ROLE_BINDING_DELETE);

const useStackRoleBindingDelete = createDefaultMutationHook(STACK_ROLE_BINDING_DELETE);

export default useStackRoleBindingDelete;
